import { render, staticRenderFns } from "./editvehicle.vue?vue&type=template&id=2918eb60&scoped=true&"
import script from "./editvehicle.js?vue&type=script&lang=js&"
export * from "./editvehicle.js?vue&type=script&lang=js&"
import style0 from "./editvehicle.vue?vue&type=style&index=0&id=2918eb60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918eb60",
  null
  
)

export default component.exports